<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s8bbhq/tc-custom/9781504084789.jpg?1728327053810" alt="This image is the cover for the book Montana, The Lola Wicks Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Montana, The Lola Wicks Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>“<b>Outstanding . . . Believable action complements razor-sharp observations of people and scenery.” —<i>Publishers Weekly, </i>starred review</b><br/>  <br/> Foreign correspondent Lola Wicks feels at home in the war zones of Afghanistan—so when her editor reassigns her from Kabul to a suburban stateside beat, she’s a fish out of water. To blow off some steam, Lola heads to Montana for some downtime at a friend’s cabin. But when she arrives, she discovers her friend has been shot dead in the hills outside her home. The murder is downright chilling—enough to make Lola want to hightail it back to Kabul. But as the first person on the scene, she’s forced to stick around. <br/>  <br/> Lola figures the only way to get out of dodge quickly is to solve the crime herself. But she’s unsettled by the strangeness of the small mountain town, which is only magnified by the tensions between the locals and the people of the nearby Blackfeet Nation. Soon Lola’s doing things she never imagined, like leaning on her new friendship with a fellow reporter—and getting up close and personal with the local sheriff. The more she’s drawn deeper into the crime, the more connected she feels to this small community under the big sky—a bond which raises the stakes on just about everything. <br/>  <br/> “Crammed with atmosphere and intriguing characters . . . A satisfying, hair-raising ride.” —<i>Kirkus Reviews</i><br/>  <br/> “A gutsy series.” —<i>The New York Times</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gwen Florio
      </h2>
      
      <p class="authorDescription body article">Gwen Florio, a former editor at the&#160;<I>Missoulian</I>, is an award-winning journalist and an adjunct professor in University of Montana&rsquo;s School of Journalism. Florio is the author of the Lola Wicks crime series as well as<I>&#160;Silent Hearts</I>, a novel set in Afghanistan. Her first novel,&#160;<I>Montana</I>, won the Pinckley Prize for Debut Novel, and a High Plains Book Award.&#160;<I>Best Laid Plans</I>,&#160;the first book in her new crime series, the Nora Best Mysteries, published in 2020. She currently lives in Montana with her partner and dog.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?764ad651